import React, { useEffect, useState } from "react";
import { Tab, Nav } from "react-bootstrap";
import { Form, message, Button, Modal, notification } from "antd";
import UiButton from "../../Common/UiButton/UiButton";
import UiDropDown from "../../Common/UiDropDown/UiDropDown";
import {
  getRejectAllDetails,
  getVerifactionMasterDetails,
} from "../../../redux/VerificationInfoMaster/action";
import { connect } from "react-redux";
import useForm from "../../Common/hooks/useForm";
import { saveRcuInfoDetails } from "../../../redux/RcuInfoEditPartner/action";
import { saveFiInfoDetails } from "../../../redux/FiInfoEditPartner/action";
import {
  saveApprovalDetails,
  saveRejectDetails,
} from "../../../redux/VerificationInfoApproval/action";
import { getVerifactionAllDetails } from "../../../redux/VerificationInfoMaster/action";
import approvedIcon from "../../../images/Approved.png";
import RejectIcon from "../../../images/rejecticon.png";
import { useLocation } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { Col, Row } from "reactstrap";
import ModalHeaderText from "../../../common/ModalHeaders/ModalHeaderText";
import TextArea from "antd/lib/input/TextArea";
import { getProgress } from "../../../redux/progressBar/action";
import useSession from "../../CustomLogout/useSession";
import { uploadDocuments } from "../../../redux/Documents/Upload/UploadDocumentsAction";
import DocumentUpoadInput from "./../../CompanyDocuments/NewUpload";
import {
  getRcuDocumentType,
  getRcuDocuments,
} from "../../../redux/Documents/Get/GetDocumentsAction";

const RCUManager = (props) => {
  const handleSessionExpired = useSession();
  const [form] = Form.useForm();
  const FormItem = Form.Item;
  const [showText, setShowText] = useState(false);

  const { state, setState, onChangeTextHandler } = useForm();

  const location = useLocation();
  const id = location?.state?.partnerFirmId;

  const [disabledText, setDisabledText] = useState(false);
  const [approve, setApprove] = useState("");
  const [approveDate, setApproveDate] = useState("");
  const [loading, setLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [hideApproveBtn, setHideApproveBtn] = useState(true);
  const [documents, setDocuments] = useState([]);
  const [hideReject, setHideReject] = useState(true);
  const [rejectIcon, setRejectIcon] = useState(false);
  const [saveBtn, setSaveBtn] = useState(true);
  const [fileList, setFileList] = React.useState([]);
  const [partnerDetatil, setPartnerDetail] = React.useState([]);
  const [RcuDocumentKey, setRcuDocumentKey] = React.useState(`${Date.now()}-1`);
  const { setFieldsValue } = form;
  const [file, setFile] = React.useState({
    base64: "",
    docExt: "",
    docName: "",
  });

  useEffect(() => {
    if (props?.activeKey == 6) {
      props.getVerifactionMasterDetails(
        props.state.accessToken.access_token,
        props.firmId
      );

      handleGetDocument();

      props
        .getRejectAllDetails(props.state.accessToken.access_token, id)
        .then((res) => {
          if (res?.status === 200)
            if (res.data?.partnerFirmStatus === "REJECTED") {
              setHideApproveBtn(false);
              setHideReject(false);
              setSaveBtn(false);
              setDisabledText(true);
              setRejectIcon(true);
              setLoading(false);
            }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        });

      // props.getVerifactionAllDetails(
      //   props.state.accessToken.access_token,
      //   props.firmId
      // );

      props
        .getRcuDocumentType({
          partnerFirmId: id,
          section: "VERIFICATION_INFO_DOCUMENTS",
        })
        .then((res) => {
          if (res?.status === 200) {
            setPartnerDetail(res?.data?.dtoList);
          }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        });

      props
        .getVerifactionAllDetails(props.state.accessToken.access_token, id)
        .then((res) => {
          if (res?.status === 200)
            form.setFieldValue("fiInfo", {
              label: res?.data?.partnerFiInfoDetails?.fiInfo?.name,
              value: res?.data?.partnerFiInfoDetails?.fiInfo?.id,
            });
          form.setFieldValue("rcuInfo", {
            label: res?.data?.partnerRcuInfoDetails?.rcuInfo?.name,
            value: res?.data?.partnerRcuInfoDetails?.rcuInfo?.id,
          });

          setState({
            rcuInfo: {
              id: res?.data?.partnerRcuInfoDetails?.rcuInfo?.id || null,
              name: res?.data?.partnerRcuInfoDetails?.rcuInfo?.name || null,
            },
            fiInfo: {
              id: res?.data?.partnerFiInfoDetails?.fiInfo?.id || null,
              name: res?.data?.partnerFiInfoDetails?.fiInfo?.name || null,
            },
          });

          if (res?.data?.partnerFirmApprovedFlag == true) {
            setShowText(true);
            setDisabledText(true);
            setHideApproveBtn(false);
            setHideReject(false);
            setSaveBtn(false);
            setRejectIcon(false);
            setApprove(res?.data?.approveBy);
            setApproveDate(formatDateAp(res?.data?.approveOn));
            setLoading(false);
          } else {
            setLoading(false);
          }

          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        });

      const fiInfoData =
        props.verificationMasterList?.verificationDetails?.data
          ?.partnerRcuInfoDetails?.rcuInfo;
    }
  }, [props?.activeKey]);

  const rejectedBy =
    props.verificationMasterList?.rejectDetails?.data?.rejectedBy;
  const rejectedOn =
    props.verificationMasterList?.rejectDetails?.data?.rejectedOn;
  const rejectedReason =
    props.verificationMasterList?.rejectDetails?.data?.rejectedReason;

  const timestamp = new Date(rejectedOn);

  const formatDate = (timestamp) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(timestamp).toLocaleDateString(undefined, options);
  };

  const datatime = formatDate(timestamp);

  const approveBy =
    props.verificationMasterList?.verificationDetails?.data?.approveBy;

  const approveOn =
    props.verificationMasterList?.verificationDetails?.data?.approveOn;

  const formatDateAp = (approveOn) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(approveOn).toLocaleDateString(undefined, options);
  };

  const datatimeAp = formatDateAp(approveOn);

  const rucListData =
    props.verificationMasterList?.data?.rcuInfoList?.length > 0
      ? props.verificationMasterList?.data?.rcuInfoList.map((el) => {
          return {
            label: el.partnerVerificationInfoName,
            value: el.partnerVerificationInfoId,
          };
        })
      : [];
  const FiListData =
    props.verificationMasterList?.data?.fiInfoList?.length > 0
      ? props.verificationMasterList?.data?.fiInfoList.map((el) => {
          return {
            label: el.partnerVerificationInfoName,
            value: el.partnerVerificationInfoId,
          };
        })
      : [];

  const handleChangeSelect = (val) => {
    setState({
      ...state,
      rcuInfo: {
        id: val.value,
        name: val.label,
      },
    });
  };

  const handleChangeRUC = (e) => {
    const valueData = {
      rcuInfo: state.rcuInfo,
    };

    props
      .saveRcuInfoDetails({
        values: valueData,
        access_token: props.access_token,
        partnerFirmId: id,
      })
      .then((res) => {
        if (res && res.status === 200) {
          message.success("Saved");
          // props.getVerifactionMasterDetails(
          //   props.state.accessToken.access_token,
          //   props.firmId
          // );
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
  };

  const handleSelectFI = (val) => {
    setState({
      ...state,
      fiInfo: {
        id: val.value,
        name: val.label,
      },
    });
  };

  const handleChangeFiInfo = (e) => {
    const valueDataFi = {
      fiInfo: state.fiInfo,
    };
    props
      .saveFiInfoDetails({
        values: valueDataFi,
        access_token: props.access_token,
        partnerFirmId: id,
      })
      .then((res) => {
        if (res && res.status === 200) {
          message.success("Saved");

          // props.getVerifactionMasterDetails(
          //   props.state.accessToken.access_token,
          //   props.firmId
          // );
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
  };

  const showModal = () => {
    setIsModalVisible(true);
    // form.resetFields();
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  const handleChangeVerifaction = () => {
    if (isModalVisible) {
      return;
    }
    setLoading(true);
    props
      .saveApprovalDetails({
        access_token: props.access_token,
        partnerFirmId: id,
      })
      .then((res) => {
        if (res && res.status === 200) {
          message.success("Saved");
          setShowText(true);
          setHideApproveBtn(false);
          setSaveBtn(false);
          setHideReject(false);
          setSaveBtn(false);
          setDisabledText(true);
          setRejectIcon(false);
          setApprove(res.data.approveBy);
          setApproveDate(formatDateAp(res.data.approveOn));
          setLoading(false);
          props.getProgress({ partnerFirmId: id });

          // props.getVerifactionMasterDetails(
          //   props.state.accessToken.access_token,
          //   props.firmId
          // );
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;
          setLoading(false);

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }

        // if (res?.data?.error) {
        //   message.error(res?.data?.error?.message, 5);
        //   setLoading(false);
        // }
      });
  };

  const handleReject = (e) => {
    e.stopPropagation();
    // psetLoading(true);
    let values = {
      deactiveReason: state.RejectionReason?.trim(),
    };
    props
      .saveRejectDetails({
        access_token: props.access_token,
        partnerFirmId: id,
        data: values,
      })
      .then((res) => {
        // setLoading(false);
        if (res && res.status === 200) {
          setIsModalVisible(false);
          message.success("Partner is deactivated");
          setShowText(false);
          setHideApproveBtn(false);
          setSaveBtn(false);
          setHideReject(false);
          setDisabledText(true);
          setRejectIcon(true);
          setLoading(false);
          props.getRejectAllDetails(props.state.accessToken.access_token, id);
          props.getProgress({ partnerFirmId: id });

          // setShowText(true);
          // props.getVerifactionMasterDetails(
          //   props.state.accessToken.access_token,
          //   props.firmId
          // );
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
  };

  const loggedInRoleType = props.userData?.loggedInRoleType ?? "";

  const onFileRemove = () => {
    setFileList([], fileList);
  };

  const onFileSelect = (info) => {
    setLoading(true);
    let fileArray = [];
    setFileList([]);
    getBase64(info, (result) => {
      let docExt;
      if (info.type === "image/jpeg") {
        docExt = "jpg";
      } else if (info.type === "image/png") {
        docExt = "png";
      } else if (info.type === "application/pdf") {
        docExt = "pdf";
      }
      const fileData = {
        name: info.name,
        uid: info.uid,
      };
      fileArray.push(fileData);
      setFileList(fileArray);
      setFile({
        base64: result,
        docExt: docExt,
        docName: info.name,
      });
      setFieldsValue({
        docFile: info.name,
      });
      let data = {
        partnerDocumentTypeId: "",
        // optionSelected: null,
        fileName: info.name,
        section: "VERIFICATION_INFO_DOCUMENTS",
        partnerTeamId: null,
        documentDetails: {
          base64: `${result}`,
          docTypeId: "",
          docExt: `${docExt}`,
        },
      };

      props.uploadDocuments({
        data,
        partnerFirmId: id,
      });
    });
  };

  const getBase64 = (file, cb) => {
    var reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = function () {
      cb(reader.result);
    };
    reader.onerror = function (error) {};
  };

  const onChange = (info) => {
    // console.log(info);
  };

  let handleGetDocument = (partnerDocumentTypeId) => {
    props
      .getRcuDocuments({
        partnerFirmId: id,
        accessToken: props.accessToken,
      })
      .then((res) => {
        if (res?.status == 200 && res?.data?.dto) {
          setDocuments([
            ...res?.data?.dto.map((el) => {
              return {
                partnerDocumentTypeId: el?.partnerDocumentTypeId,
                url: el?.documentLink,
                status: "done",
                uid: el?.uid,
                name: el?.fileName ?? "View Document",
              };
            }),
          ]);
          setRcuDocumentKey(`${Date.now()}-1`);
        }
      });
  };

  return !loading ? (
    <div className="inner-Tab-sec-edit-pat">
      <Modal
        open={isModalVisible}
        closable={false}
        className="modal-container"
        centered
        footer={null}
      >
        {" "}
        <Row>
          <Col lg={12} xs={12} md={12} sm={12}>
            <Col md={12} className="headre-login">
              <ModalHeaderText LoginHeading="Reject Partner" />
            </Col>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col md={12}>
            <p>
              By Clicking on confirm, the partner will be rejected and will not
              be able to add leads into the system. However his earlier leads
              will still be active and accessible to the Avanse Teams.
            </p>
          </Col>
        </Row>
        <Row className="form-group">
          <Col md={12}>
            <TextArea
              type="text"
              title="Reason of Activated"
              id="reasonOfDeactivation"
              maxLength={255}
              placeholder="Enter Reason of Activation"
              autoComplete="off"
              className="floating-input floating-textarea"
              rows={4}
              validation={[
                {
                  required: true,
                  message: "Please Enter Reason of Activation",
                },
              ]}
              name="RejectionReason"
              onChange={onChangeTextHandler}
            />
          </Col>
        </Row>
        <Row className="">
          <Col md={12} className="d-flex justify-content-end">
            <Button
              className="mr-3"
              htmlType="text-btn-sec"
              type="default"
              onClick={handleCancel}
            >
              CANCEL
            </Button>
            <Button
              onClick={(e) => {
                handleReject(e);
              }}
              className=""
              htmlType="text-btn-sec"
              type="primary"
            >
              CONFIRM
            </Button>
          </Col>
        </Row>
      </Modal>
      <Tab.Container id="left-tabs-example" defaultActiveKey="first">
        <Row>
          <Col sm={2} className="left-side-tabs">
            <Nav variant="pills" className="flex-column">
              <Nav.Item>
                <Nav.Link eventKey="first">
                  <div className="tab-selet-test">
                    <h4>Verfication Info</h4>
                  </div>
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
          <Col sm={10}>
            <Tab.Content>
              <Tab.Pane eventKey="first">
                <Form
                  autoComplete="off"
                  name="verficationInfo"
                  form={form}
                  onFinish={handleChangeVerifaction}
                >
                  <Row>
                    <Col md={6} className="RCU-INFO-sec">
                      <h3>
                        RCU INFO <span style={{ color: "red" }}>* </span>
                      </h3>
                      <Row>
                        <Col md={8}>
                          {" "}
                          <FormItem
                            name="rcuInfo"
                            colon={false}
                            rules={[
                              {
                                required: true,
                                message: "Please Enter RCU INFO",
                              },
                            ]}
                          >
                            <UiDropDown
                              data={rucListData}
                              onChange={handleChangeSelect}
                              disabled={
                                disabledText || loggedInRoleType === "RM"
                              }
                            />
                          </FormItem>
                        </Col>
                        <Col md={4}>
                          {saveBtn ? (
                            <UiButton
                              type="button"
                              disabled={loggedInRoleType === "RM"}
                              title="Save"
                              onClick={handleChangeRUC}
                            />
                          ) : null}
                        </Col>
                      </Row>
                    </Col>
                    <Col md={6} className="">
                      <h3>
                        FI INFO <span style={{ color: "red" }}>* </span>
                      </h3>

                      <Row>
                        <Col md={8}>
                          <FormItem
                            name="fiInfo"
                            colon={false}
                            rules={[
                              {
                                required: true,
                                message: "Please Enter FI INFO",
                              },
                            ]}
                          >
                            <UiDropDown
                              onChange={handleSelectFI}
                              data={FiListData}
                              disabled={
                                disabledText || loggedInRoleType === "RM"
                              }
                            />
                          </FormItem>
                        </Col>

                        <Col md={4}>
                          {saveBtn ? (
                            <UiButton
                              disabled={loggedInRoleType === "RM"}
                              type="button"
                              title="Save"
                              onClick={handleChangeFiInfo}
                            />
                          ) : null}
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  {loggedInRoleType === "CET" && (
                    <>
                      {rejectIcon ? (
                        <>
                          <Row>
                            <Col
                              lg={12}
                              xs={12}
                              md={12}
                              sm={12}
                              className="inner-field-right"
                            >
                              {documents.length > 0
                                ? documents.map((el) => {
                                    console.log(el);
                                    return (
                                      <>
                                        <Col md={4} className="">
                                          <div className="text-reject">
                                            <div className="sec-text">
                                              <h3>Documents</h3>
                                              <a href={el?.url}>
                                                <h4 style={{ color: "blue" }}>
                                                  View Document
                                                </h4>
                                              </a>
                                            </div>
                                          </div>
                                        </Col>
                                      </>
                                    );
                                  })
                                : ""}

                              <Col md={4} className="">
                                <img
                                  className="verifi-ic-btn"
                                  src={RejectIcon}
                                  alt=""
                                />
                              </Col>
                            </Col>
                          </Row>
                        </>
                      ) : null}{" "}
                      {showText ? (
                        <>
                          <Row>
                            <Col
                              lg={12}
                              xs={12}
                              md={12}
                              sm={12}
                              className="inner-field-right"
                            >
                              {documents.length > 0
                                ? documents.map((el) => {
                                    console.log(el);
                                    return (
                                      <>
                                        <Col md={4} className="">
                                          <div className="text-reject">
                                            <div className="sec-text">
                                              <h3>Documents</h3>
                                              <a href={el?.url}>
                                                <h4 style={{ color: "blue" }}>
                                                  View Document
                                                </h4>
                                              </a>
                                            </div>
                                          </div>
                                        </Col>
                                      </>
                                    );
                                  })
                                : ""}

                              <Col md={4} className="">
                                <img
                                  className="verifi-ic-btn"
                                  src={approvedIcon}
                                  alt=""
                                />
                              </Col>
                            </Col>
                          </Row>
                        </>
                      ) : null}
                      <Row>
                        <Col
                          lg={12}
                          xs={12}
                          md={12}
                          sm={12}
                          className="inner-field-right"
                        >
                          <Col md={12}>
                            {loading && (
                              <div className="pr-4 spanner">
                                <Spin
                                  size="large"
                                  className="pr-4"
                                  indicator={
                                    <LoadingOutlined
                                      style={{ color: "#00d8db" }}
                                    />
                                  }
                                ></Spin>
                              </div>
                            )}
                            {showText || rejectIcon ? (
                              <div></div>
                            ) : (
                              <>
                                <Row>
                                  <Col
                                    lg={12}
                                    xs={12}
                                    md={12}
                                    sm={12}
                                    className="inner-field-right"
                                  >
                                    {console.log("documentData", documents)}
                                    {partnerDetatil.length > 0
                                      ? partnerDetatil.map((el) => {
                                          return (
                                            <>
                                              <Col md={6} className="">
                                                <div className="ruc-document-sec">
                                                  <h3>
                                                    {`Upload ${el?.dmsDocTypeName}`}{" "}
                                                    <span
                                                      style={{ color: "red" }}
                                                    >
                                                      *{" "}
                                                    </span>
                                                  </h3>
                                                  <DocumentUpoadInput
                                                    listType="picture"
                                                    className="selected-optdoc rcu"
                                                    setDisabled={() => {}}
                                                    key={RcuDocumentKey}
                                                    type="Button"
                                                    getRcuDocuments={() => {
                                                      handleGetDocument(
                                                        el?.partnerDocumentTypeId
                                                      );
                                                    }}
                                                    partnerFirmId={id}
                                                    progress={{
                                                      strokeWidth: 0,
                                                      showInfo: false,
                                                    }}
                                                    item={{
                                                      partnerDocumentTypeId:
                                                        el?.partnerDocumentTypeId,
                                                      dmsDocTypeId:
                                                        el?.dmsDocTypeId,
                                                      section: el?.section,
                                                    }}
                                                    showUploadList={{
                                                      showRemoveIcon: false,
                                                    }}
                                                    accept=".pdf,.png,.jpg"
                                                    beforeUpload={(e) =>
                                                      onFileSelect(e)
                                                    }
                                                    onRemove={onFileRemove}
                                                    maxCount={1}
                                                    onChange={onChange}
                                                    defaultFileList={documents?.filter(
                                                      (ell) => {
                                                        return (
                                                          ell?.partnerDocumentTypeId ==
                                                          el.partnerDocumentTypeId
                                                        );
                                                      }
                                                    )}
                                                  />
                                                </div>
                                              </Col>
                                            </>
                                          );
                                        })
                                      : ""}
                                  </Col>
                                </Row>
                              </>
                            )}
                          </Col>
                        </Col>
                      </Row>
                    </>
                  )}
                </Form>
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>
  ) : (
    <div>Data not Available</div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getVerifactionMasterDetails: (accessToken, partnerFirmId) =>
      dispatch(getVerifactionMasterDetails(accessToken, partnerFirmId)),
    getVerifactionAllDetails: (accessToken, partnerFrimID) =>
      dispatch(getVerifactionAllDetails(accessToken, partnerFrimID)),
    getRejectAllDetails: (accessToken, partnerFrimID) =>
      dispatch(getRejectAllDetails(accessToken, partnerFrimID)),

    saveRcuInfoDetails: (data) => dispatch(saveRcuInfoDetails(data)),
    saveFiInfoDetails: (data) => dispatch(saveFiInfoDetails(data)),
    saveApprovalDetails: (data) => dispatch(saveApprovalDetails(data)),
    saveRejectDetails: (data) => dispatch(saveRejectDetails(data)),
    getProgress: (data) => dispatch(getProgress(data)),
    uploadDocuments: (user) => dispatch(uploadDocuments(user)),
    getRcuDocuments: (data) => dispatch(getRcuDocuments(data)),
    getRcuDocumentType: (data) => dispatch(getRcuDocumentType(data)),
  };
};

const mapStateToProps = (state) => {
  return {
    state: state && state.auth,
    access_token: state && state.auth && state.auth.idToken,
    verificationMasterList: state.verificationMasterList,
    userData: state?.auth?.userData,
    editPartner: state.editPartner.editPartner,
    firmId:
      state.auth?.checkLogin?.partnerFirmId ||
      state?.auth?.loginCredentials?.data?.partnerFirmDetails?.partnerFirmId ||
      sessionStorage.getItem("cetFirmId"),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RCUManager);
